
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryConfigurationTrials, QueryConfigurationTrialsResponse, ConfigurationTrial } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QueryConfigurationTrialsResponse, QueryConfigurationTrialsResponse>) => response?.data?.data?.find(x => true);
const getError = (response?: SWRResponse<QueryConfigurationTrialsResponse, QueryConfigurationTrialsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QueryConfigurationTrialsResponse, QueryConfigurationTrialsResponse>) => ({});

export const useConfigurationTrial = (query?: Partial<ConfigurationTrial>, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new QueryConfigurationTrials(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationTrial;